// WalletAnalytics.jsx
import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import WalletChart from "./WalletChart";

/* viewport helpers */
const FRAME_WIDTH = 480;
const WIDTH       = Math.min(Math.max(window.innerWidth,320),FRAME_WIDTH);
const HEIGHT      = Math.min(Math.max(window.innerHeight,640),920);

export default function WalletAnalytics() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const dat       = location.state?.dat || {};

  /* sum royalties across owned editions */
  const totalRoyaltyPercentage = useMemo(
    () => (dat.ownedEditions || []).reduce(
      (sum, ed) => sum + (ed.royalties || 0), 0
    ),
    [dat.ownedEditions]
  );

  if (!dat.id) {
    return (
      <div style={styles.fallback}>
        <p style={{ color: "#fff" }}>No DAT provided.</p>
      </div>
    );
  }

  return (
    <div style={styles.fullScreen}>
      <img
        src={require("./assets/BlankBG.png")}
        alt=""
        style={styles.bgImg}
      />

      {/* ─── header ─── */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>
          <IoArrowBack size={22} color="#fff" style={{ marginRight: 6 }} />
        </button>
        <span style={styles.title}>{dat.SongName}</span>
      </div>

      {/* ─── artwork + chart ─── */}
      <div style={styles.body}>
        <img src={dat.ArtworkURL} alt="artwork" style={styles.artwork} />
        <WalletChart
          assetId={dat.id}
          songName={dat.SongName}
          royaltyPercentage={totalRoyaltyPercentage}
        />
      </div>
    </div>
  );
}

/* ───────── styles ───────── */
const styles = {
  fullScreen: {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "brhendrix",
  },
  bgImg: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: 0,
  },
  header: {
    display: "flex",
    alignItems: "center",
    padding: "16px 15px 4px",
    position: "relative",
    zIndex: 2,
  },
  backBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 4,
  },
  title: {
    position: "absolute",
    left: 0,
    right: 0,

    maxWidth: WIDTH - 80,               // leave room for back button
    margin: "0 auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    color: "#fff",
    fontSize: WIDTH * 0.045,            // ≈ 22 px on 480-wide
  },
  body: {
    position: "relative",
    zIndex: 1,

    marginBottom: HEIGHT * 0.14,
    width: WIDTH,                                            // << new
    maxWidth: FRAME_WIDTH,                                   // << new
    marginLeft: "auto",                                      // << new
    marginRight: "auto",                                     // << new
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  artwork: {
    width: "100%",
    maxHeight: '410px',
    objectFit: "cover",

  },
  fallback: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100vh",
    background: "#0e061e",
  },
};
